import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';

export const useServiceUpdateCardStyles = createStyles(({ token }) => ({
  serviceUpdateCard: {
    margin: `${ThemeSpaces.SPACE_SM}px 0 ${ThemeSpaces.SPACE_NORM}px 0`,

    '&&&': {
      '.SimpleCard-Header': {
        height: 40,
        backgroundColor: ThemeColors.COLOR_ORANGE3,

        'h4.ant-typography': {
          color: token.colorWhite,
          lineHeight: '16px',
          marginTop: token.marginXXS,
        },
      },
    },
    '&&&.no-phone': {
      '.SimpleCard-Header': {
        height: 24,
      },
    },
  },
  subtitle: {
    fontSize: token.fontSizeSM,
    textTransform: 'none',
  },
  groupTitle: {
    fontSize: token.fontSize,
    fontWeight: 700,
    paddingTop: ThemeSpaces.SPACE_NORM,
    color: ThemeColors.COLOR_ORANGE3,
  },
  reason: {
    fontWeight: 500,
  },
  serviceAdvisoryCard: {
    marginTop: 0,

    '&&&': {
      '.SimpleCard-Body': {
        borderRadius: 'unset',
      },
    },
  },
  serviceAdvisorySection: {
    padding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_NORM_20}px`,
  },
  groupTitleAdvisory: {
    '&&': {
      padding: 0,
    },
    '> p, .ant-typography': {
      fontSize: token.fontSize,
      lineHeight: '18px',
      color: ThemeColors.COLOR_ORANGE3,
      fontWeight: 400,
      textAlign: 'center',
    },
    '.ant-typography': {
      fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
      margin: 0,
    },
  },
  availabilityParagraph: {
    marginBottom: ThemeSpaces.SPACE_NORM0_5,
  },
}));
